import React, { useEffect, useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import {
  ApproveReimbursementFilterType,
  ColXsMdType,
  LocationFilterType,
  SelectOptionType,
} from '../utils/Types';
import {
  DEFAULT_OPTION,
  DEFAULT_OPTION_LOCATION,
  ROLE_POSP,
  ROLE_KSHEMA_POSP,
  TEXT_ONLY_REGEX,
} from '../utils/Constant';
import SearchBox from '../components/SearchBox';
import LocationFilter from './LocationFilter';
import { useAppDispatch, useAppSelector } from '../store/redux-hooks';
import { trackLocationSelector } from '../features/trackLocationSlice';
import SelectBox from '../components/SelectBox';
import {
  fetchReimbursementStatusDrops,
  reimbursementSelector,
} from '../features/reimbursementSlice';

interface IApproveReimbursementFilterProps {
  onApplyFilters: (filter: ApproveReimbursementFilterType) => void;
}

const defaultFilterDate: ApproveReimbursementFilterType = {
  employeeId: '',
  employeeName: '',
  zone: DEFAULT_OPTION_LOCATION,
  state: DEFAULT_OPTION_LOCATION,
  city: DEFAULT_OPTION_LOCATION,
  district: DEFAULT_OPTION_LOCATION,
  role: DEFAULT_OPTION,
  status: DEFAULT_OPTION_LOCATION,
};
const colSize: ColXsMdType = {
  xs: 6,
  md: 3,
};
const ApproveReimbursementFilter: React.FunctionComponent<
  IApproveReimbursementFilterProps
> = ({ onApplyFilters }) => {
  const dispatch = useAppDispatch();
  const [filter, setFilter] =
    useState<ApproveReimbursementFilterType>(defaultFilterDate);
  const roleOptions = useAppSelector(trackLocationSelector).roleOptions;
  const statusDropOptions: SelectOptionType[] = useAppSelector(
    reimbursementSelector
  ).statusDropOptions;

  const onResetFilter = () => {
    onApplyFilters(defaultFilterDate);
    setFilter(defaultFilterDate);
  };

  useEffect(() => {
    dispatch(fetchReimbursementStatusDrops({ module: 7 }));
  }, []);
  return (
    <div className="border rounded ps-3 pt-2 pe-3">
      <Row>
        <Col md={3}>
          <SearchBox
            label="Employee Id"
            placeHolder="Ex. 401264"
            value={filter.employeeId}
            onChange={(e: any) => {
              setFilter({
                ...filter,
                employeeId: e.target.value,
              });
            }}
          />
        </Col>
        <Col md={3}>
          <SearchBox
            label="Employee Name"
            placeHolder="Ex. John Doe"
            value={filter.employeeName}
            onChange={(e: any) => {
              const text = e.target.value.trim();
              if (TEXT_ONLY_REGEX.test(text) || text === '') {
                setFilter({
                  ...filter,
                  employeeName: e.target.value,
                });
              }
            }}
          />
        </Col>
        <Col md={3}>
          <SelectBox
            label="Role"
            value={filter.role}
            options={roleOptions?.filter(
              ({ value }) => value !== ROLE_POSP && value !== ROLE_KSHEMA_POSP
            )}
            onChange={(event: any) => {
              setFilter({
                ...filter,
                role: event,
              });
            }}
          />
        </Col>
        <Col xs={6} md={3}>
          <SelectBox
            label="Status"
            options={[DEFAULT_OPTION_LOCATION, ...statusDropOptions]}
            className="css-select-bg"
            value={filter.status}
            onChange={(event: SelectOptionType) => {
              setFilter({
                ...filter,
                status: event,
              });
            }}
            showClear={false}
          />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <LocationFilter
            size={{
              zone: colSize,
              state: colSize,
              district: colSize,
              city: colSize,
            }}
            filterData={{
              zone: filter.zone,
              state: filter.state,
              district: filter.district,
              city: filter.city,
            }}
            setLocationFilter={(locationFilter: LocationFilterType) => {
              setFilter({
                ...filter,
                zone: locationFilter.zone,
                state: locationFilter.state,
                city: locationFilter.city,
                district: locationFilter.district,
              });
            }}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={6} md={4}>
          <div className="d-flex justify-content-left mb-3 pt-1">
            <Button
              variant="primary"
              className="cl-btn-primary"
              onClick={() => {
                onApplyFilters(filter);
              }}
            >
              Search
            </Button>
            <Button
              variant="outline-primary"
              className="mx-2 cl-btn-outline-primary"
              onClick={() => {
                onResetFilter();
              }}
            >
              Reset
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ApproveReimbursementFilter;
